import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, Twitter, Linkedin, Github, Mail } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-950 border-t border-slate-800 pt-16 pb-8" data-id="element-15">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12" data-id="element-17">
          <div className="col-span-1 md:col-span-1" data-id="element-18">
            <Link to="/" className="flex items-center space-x-2 mb-4" data-id="element-19">
              <Activity className="h-8 w-8 text-cyan-500" data-id="element-20" />
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-21">
                njgod
              </span>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed" data-id="element-22">
              World's fastest and most in-depth network analytics platform.
              Empowering enterprise teams with real-time insights.
            </p>
          </div>

          <div data-id="element-23">
            <h3 className="text-white font-semibold mb-4" data-id="element-24">Product</h3>
            <ul className="space-y-2" data-id="element-25">
              <li data-id="element-26">
                <Link to="/features" className="text-slate-400 hover:text-cyan-400 text-sm" data-id="element-27">
                  Features
                </Link>
              </li>
              <li data-id="element-28">
                <Link to="/pricing" className="text-slate-400 hover:text-cyan-400 text-sm" data-id="element-29">
                  Pricing
                </Link>
              </li>
              <li data-id="element-30">
                <Link to="/resources" className="text-slate-400 hover:text-cyan-400 text-sm" data-id="element-31">
                  API
                </Link>
              </li>
              <li data-id="element-32">
                <a href="https://app.njgod.com" className="text-slate-400 hover:text-cyan-400 text-sm" data-id="element-33">
                  Login
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-34">
            <h3 className="text-white font-semibold mb-4" data-id="element-35">Company</h3>
            <ul className="space-y-2" data-id="element-36">
              <li data-id="element-37">
                <Link to="/about" className="text-slate-400 hover:text-cyan-400 text-sm" data-id="element-38">
                  About Us
                </Link>
              </li>
              <li data-id="element-39">
                <Link to="/contact" className="text-slate-400 hover:text-cyan-400 text-sm" data-id="element-40">
                  Contact
                </Link>
              </li>
              <li data-id="element-41">
                <Link to="/resources" className="text-slate-400 hover:text-cyan-400 text-sm" data-id="element-42">
                  Blog
                </Link>
              </li>
              <li data-id="element-43">
                <Link to="/resources" className="text-slate-400 hover:text-cyan-400 text-sm" data-id="element-44">
                  Careers
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-45">
            <h3 className="text-white font-semibold mb-4" data-id="element-46">Connect</h3>
            <div className="flex space-x-4" data-id="element-47">
              <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-48">
                <Twitter className="h-5 w-5" data-id="element-49" />
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-50">
                <Linkedin className="h-5 w-5" data-id="element-51" />
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-52">
                <Github className="h-5 w-5" data-id="element-53" />
              </a>
              <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-54">
                <Mail className="h-5 w-5" data-id="element-55" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-56">
          <p className="text-slate-500 text-sm" data-id="element-57">
            © {new Date().getFullYear()} njgod. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-58">
            <Link to="/resources" className="text-slate-500 hover:text-slate-300 text-sm" data-id="element-59">
              Privacy Policy
            </Link>
            <Link to="/resources" className="text-slate-500 hover:text-slate-300 text-sm" data-id="element-60">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </footer>;
}